// eslint-disable-next-line no-shadow
export enum PeriodType {
  MONTH = 'Month',
  PAY_PERIOD = 'Pay Period'
}

export interface PeriodTypeSelectorProps {
  selectedPeriod: PeriodType;
  onPeriodChange: (period: PeriodType) => void;
  disabled?: boolean;
}